<template>
  <div class="list-empty-wrapper">
    <div class="img-box" />
    <p class="label">{{ text }}</p>
  </div>
</template>

<script>
export default {
  name: 'ListEmpty',
  props: {
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
.list-empty-wrapper {
  padding-top: 50px;
  text-align: center;
  .img-box {
    @include wh(170px, 170px);
    @include bg-image-png('/error/empty');
    @include bg-image-fit;
    margin: auto;
  }
  .label {
    @include ft($font-size-md, 14px);
    margin-top: 16px;
  }
}
</style>
